import { useEffect, useState } from 'react';
import { fetchBlogBySlug, fetchRelatedPosts } from './blogApi';

const useBlogDetails = (slug) => {
  const [post, setPost] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [relatedLoading, setRelatedLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return undefined;

    let active = true;

    const load = async () => {
      setLoading(true);
      setRelatedLoading(true);
      setError(null);
      setPost(null);
      setRelated([]);

      try {
        const details = await fetchBlogBySlug(slug);
        if (!active) return;
        setPost(details);
        setLoading(false);

        try {
          const relatedPosts = await fetchRelatedPosts(slug);
          if (!active) return;
          setRelated(relatedPosts);
        } catch {
          if (!active) return;
          setRelated([]);
        } finally {
          if (active) setRelatedLoading(false);
        }
      } catch (err) {
        if (!active) return;
        setError(err);
        setPost(null);
        setLoading(false);
        setRelatedLoading(false);
      }
    };

    load();

    return () => {
      active = false;
    };
  }, [slug]);

  return {
    post,
    related,
    loading,
    relatedLoading,
    error,
  };
};

export default useBlogDetails;
